<template>
  <div class="login-align-center">
    <v-row no-gutters class="login-grid">
      <v-col class="login-controls-cell">
        <div class="control-container-right">
          <div class="controls-flex">
            <div class="mt-2">
              <img class="login-logo-image" :src="'/v2/images/logo-soma.png'" />
            </div>
            <login-main-sign-in-options />
            <div class="mb-4">
              <a class="no-link-styling" href="/lietosanas-noteikumi">
                Lietošanas noteikumi un privātuma politika
              </a>
            </div>
          </div>
        </div>
      </v-col>
      <v-col class="login-image-cell">
        <img class="login-image" :src="'/v2/images/login.png'" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  setup() {
    definePageMeta({
      layout: "plain",
      middleware: ["skip-login"],
    })
  },
}
</script>

<style lang="sass" scoped>
@use "~/assets/css/vuetify/settings" as *

.login-align-center
  height: 100%
  display: flex
  align-content: center
  align-items: center
.login-grid
  padding: 20px 20px 0 20px
.login-controls-cell
  flex-shrink: 2
  flex-grow: 1
.login-image-cell
  height: 100%
.login-logo-image
  width: 308px
.login-image
  width: 100%
  max-height: 786px
  max-width: 672px

.control-container-right
  justify-content: flex-end
  justify-items: flex-end
  display: flex
  height: 100%
  width: 100%

.controls-flex
  display: flex
  flex-flow: column
  justify-items: center
  justify-content: space-between
  height: 100%
  width: 100%
  max-width: 600px
  > div
    display: flex
    justify-items: center
    justify-content: center

.no-link-styling
  text-decoration: inherit
  color: inherit

@media #{map-get($display-breakpoints, 'sm-and-down')}
  .login-grid
    height: 100%
  .login-image-cell
    display: none
  .control-container-right
    justify-content: center
    justify-items: items
</style>
